import * as React from 'react'
import { useContext } from 'react'
import { useQuery } from 'react-query'
import { useStorageState } from 'react-storage-hooks'
import Table from './Table'
import Filter from './Filter'
import CommonContext from '../CommonContext'
import { getResourcesOverview } from '../../api/resources'
import ErrorMessage from '../job_plannings/list_app/ErrorMessage'
import TagsSection from './TagsSection'

type ResourcesOverviewProps = {
  startDate: string
  endDate: string
}

export default function ResourcesOverview({ startDate, endDate }: ResourcesOverviewProps) {
  const dictionaries = useContext(CommonContext)
  const { currentUser } = dictionaries

  const [filter, setFilter] = useStorageState(sessionStorage, 'filter', { no: [currentUser.username], department_ids: [] })
  const [showWeekends, setShowWeekends] = useStorageState(sessionStorage, 'showWeekends', true)
  const [showNormTime, setShowNormTime] = useStorageState(sessionStorage, 'showNormTime', false)
  const { isLoading, isError, data, error } = useQuery(['resources_overview', startDate, endDate, filter], () =>
    getResourcesOverview({ date: startDate, filter })
  )

  return (
    <>
      <Filter
        initialFilter={filter}
        onSubmit={newFilter => {
          setFilter(newFilter)
        }}
      />
      {isLoading && (
        <div className="text-center">
          <i className="fa fa-spinner fa-spin fa-2x" />
        </div>
      )}
      <div className="row">
        <div className="col-xs-12">
          {!isLoading && !isError && (
            <div className="form-check form-check-valigned">
              <label>
                <input type="checkbox" checked={showWeekends} onChange={e => setShowWeekends(e.target.checked)} />
                Weekend og helligdage
              </label>
              <label>
                <input className="ml-4" type="checkbox" checked={showNormTime} onChange={e => setShowNormTime(e.target.checked)} />
                Show only Norm time
              </label>
            </div>
          )}
        </div>
      </div>
      {!isLoading && !isError && (
        <>
          <Table
            startDate={startDate}
            endDate={endDate}
            data={data}
            showWeekends={showWeekends}
            showNormTime={showNormTime}
            availableDepartments={dictionaries.availableDepartments}
            currentUser={currentUser}
          />
          <TagsSection />
        </>
      )}
      <ErrorMessage isError={isError} error={error} className="job-plannings-table-error" />
    </>
  )
}
